export let localeSwedish = {
    // for filter panel
    page: 'Sida',
    to: 'till',
    of: 'av',
 
    // other
    noRowsToShow: ' ',

    // for number filter and text filter
    filterOoo: 'Filter...',
    applyFilter: 'Applicera filter',
    equals: 'Lika med',
    notEqual: 'Ej lika med',

     // for number filter
    lessThan: 'Mindre än',
    greaterThan: 'Större än',
    lessThanOrEqual: 'Mindre eller lika med',
    greaterThanOrEqual: 'Större eller lika med',
    inRange: 'Intervall',

    // for text filter
    contains: 'Innehåller',
    notContains: 'Innehåller inte',
    startsWith: 'Inleds med',
    endsWith: 'Avslutas med',

    and: 'Och',
    or: 'Eller',

    // standard menu
    copy: 'Kopiera',
    copyWithHeaders: 'Kopiera med rubrik',
    ctrlC: 'ctrl-C',
    paste: 'Klistra in',
    ctrlV: 'ctrl-V'
  }
